var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionCashflowStreamlineCore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Subscription-Cashflow--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Subscription Cashflow Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subscription-cashflow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.35102 5.30659c-0.05122 -0.14491 -0.13026 -0.27668 -0.23069 -0.38889 -0.21363 -0.23868 -0.52407 -0.38889 -0.8696 -0.38889h-0.90305c-0.57515 0 -1.04141 0.46625 -1.04141 1.04141 0 0.4894 0.34077 0.91277 0.81887 1.01735l1.3749 0.30076c0.5356 0.11717 0.91736 0.5918 0.91736 1.14007 0 0.64433 -0.52234 1.1671 -1.16667 1.1671h-0.77778c-0.50798 0 -0.94013 -0.32465 -1.10029 -0.77778",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2489",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.86194 4.52898V3.3623",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2490",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M6.86194 10.3622V9.19556",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.99841 13.4985v-2.5h2.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1132",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M13.3881 5.80396c0.622 3.30794 -1.4023 6.58744 -4.70733 7.47294 -2.52955 0.6778 -5.11054 -0.2339 -6.68248 -2.1229",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1133",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.611985 8.19607C-0.0100566 4.88813 2.01426 1.60867 5.31929 0.723095 7.84867 0.0453494 10.4295 0.95692 12.0015 2.84565",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.0015 0.501709V3.00171H9.50146",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionCashflowStreamlineCore);
export default __webpack_public_path__ + "static/media/Subscription-Cashflow--Streamline-Core.1755cf96b1175c4a80cbb3ce3170d60d.svg";
export { ForwardRef as ReactComponent };